import type {
  RichText,
  RichTextElement,
} from '../../../../core/data-sources/content-components/types.js';

import { safeParseJson } from '../../../helpers/safe-parse-json.js';

export interface Faq {
  question: RichTextElement;
  answers: RichText;
}

export function buildFaq(faq: string): Faq[] | null {
  const parsed = safeParseJson<string | RichText>(faq, faq);

  if (typeof parsed === 'string') return null;

  const faqs: Faq[] = [];
  let currentQuestion: RichTextElement | null = null;
  let currentAnswers: RichText = [];

  parsed.forEach((block, index) => {
    if ('text' in block && block.text.value.includes('?')) {
      if (currentQuestion) {
        faqs.push({ question: currentQuestion, answers: [...currentAnswers] });
        currentAnswers = [];
      }
      currentQuestion = block;
    } else if (currentQuestion) {
      currentAnswers.push(block);
      if (index === parsed.length - 1) {
        faqs.push({ question: currentQuestion, answers: [...currentAnswers] });
      }
    }
  });

  return faqs;
}
